import React from 'react';
import PropTypes from 'prop-types';

export default function NumericField({ content }) {
  return (
    <span className="numeric">
      {content}
    </span>
  );
}

NumericField.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};
